
import { ChargingStation } from '@/types/task';
import { ZapIcon } from 'lucide-react';

interface PricingSummaryProps {
  station: ChargingStation;
  duration: number;
  totalPrice: number;
}

export const PricingSummary = ({ station, duration, totalPrice }: PricingSummaryProps) => {
  return (
    <div className="flex-1 border rounded-lg p-4 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <ZapIcon className="h-5 w-5 text-yellow-500" />
          <span className="font-medium">{station.powerOutput} kW</span>
        </div>
        <span className="font-medium">${station.price.toFixed(2)}/kWh</span>
      </div>

      <div className="border-t pt-4">
        <h3 className="font-medium text-lg">Booking Summary</h3>
        <div className="mt-2 space-y-2">
          <div className="flex justify-between">
            <span>Charging Rate</span>
            <span>${station.price.toFixed(2)}/kWh</span>
          </div>
          <div className="flex justify-between">
            <span>Estimated Energy</span>
            <span>{(station.powerOutput * duration).toFixed(1)} kWh</span>
          </div>
          <div className="flex justify-between">
            <span>Base Price</span>
            <span>${(totalPrice / 1.05).toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>Service Fee (5%)</span>
            <span>${(totalPrice - (totalPrice / 1.05)).toFixed(2)}</span>
          </div>
          <div className="flex justify-between font-bold text-lg pt-2 border-t">
            <span>Total Price</span>
            <span>${totalPrice.toFixed(2)}</span>
          </div>
        </div>
      </div>

      {station.amenities && station.amenities.length > 0 && (
        <div className="border-t pt-4">
          <h3 className="font-medium">Available Amenities</h3>
          <ul className="mt-2 grid grid-cols-2 gap-1">
            {station.amenities.map((amenity, index) => (
              <li key={index} className="flex items-center">
                <span className="text-sm">{amenity}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
